import {useMemo} from 'react';
import isMobileApp from '../utils/isMobileApp';

const useIsMobileApp = () =>
  useMemo(() => isMobileApp(window.navigator?.userAgent || ''), []);

export default useIsMobileApp;
